import { createAsyncThunk } from "@reduxjs/toolkit";
import { URLS } from 'constants/api.constants';
import { axiosInstance } from 'utils/axios';

export const blogGet = createAsyncThunk(
  'blog/blog',
  async (
    { page = 1, limit = 10, search = '', sort_column = 'blog_id', sort_order = 'desc', type } = {},
    { thunkAPI }
  ) => {
    try {
      const params = {
        page,
        limit,
        sort_column,
        sort_order,
      };

      // Add search parameter in the correct format
      if (search) {
        params.search = { value: search };
      }

      // Add type parameter if provided
      if (type) {
        params.type = type;
      }

      const response = await axiosInstance.get(URLS.BLOG.GET_ALL_BLOG, {
        params,
      });
      if (response.data?.success) {
        return response.data.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch blogs'
        );
      }
    } catch (error) {
      console.error('Blog API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching blogs'
      );
    }
  }
);
export const getBlogById = createAsyncThunk(
  'blog/blogById',
  async (id, { thunkAPI }) => {
    try {
      const response = await axiosInstance.get(`${URLS.BLOG.GET_SINGLE_BLOG}/${id}`);
      if (response.data?.success) {
        return response.data.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch blog'
        );
      }
    } catch (error) {
      console.error('Blog API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching blog'
      );
    }
  }
)